import React, { useState } from "react";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useRequestProcessor } from "../../../requestProcessor";
import { useAtom } from "jotai";
import { activeChildDetail, GrowthAtom } from "../../../AtomStore/store";
import { fetchMeasurement } from "../../../QueryFunctions/queryfunction";

import Item from "./Item";

// Register Chart.js components and the plugin
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const Measurement1 = () => {
  const { useQueryWrapper } = useRequestProcessor();
  const [measurements, setMeasurement] = useAtom(GrowthAtom);
  const [currentIndex, setCurrentIndex] = useState(0);

  const [activeChild] = useAtom(activeChildDetail);

  const { isLoading, isFetching } = useQueryWrapper(
    ["measurements", activeChild?.id],
    () => fetchMeasurement(),
    {
      onSuccess: (data) => {
        console.log("[Measurement] Measurement response:", data);
        setMeasurement(data);
      },
    }
  );
  console.log("Measurement", measurements);

  let sortedArray =
    measurements && measurements.length > 0
      ? measurements[currentIndex]?.data.sort((a, b) => a.month - b.month)
      : [];

  return (
    <>
      {isFetching || isLoading ? (
        <>
          <div className="flex justify-between px-3 py-3 text-center shadow-md rounded-lg animate-pulse">
            <div className="flex-1 flex flex-col gap-3 items-center justify-center">
              <div className="bg-slate-300 h-4 w-10 rounded"></div>
              <div className="bg-slate-300 h-4 w-10 rounded"></div>
              <div className="text-sm text-gray-500">Start</div>
            </div>
            <div className="w-[2px] bg-gray"></div>
            <div className="flex-1 flex flex-col gap-3 items-center justify-center">
              <div className="bg-slate-300 h-4 w-10 rounded"></div>
              <div className="bg-slate-300 h-4 w-10 rounded"></div>
              <div className="text-sm text-gray-500">Today</div>
            </div>
            <div className="w-[2px] bg-gray"></div>
            <div className="flex-1 flex flex-col gap-3 items-center justify-center">
              <div className="bg-slate-300 h-4 w-10 rounded"></div>
              <div className="bg-slate-300 h-4 w-10 rounded"></div>
              <div className="text-sm text-gray-500">Change</div>
            </div>
          </div>
          <div className="my-3 border-0 shadow bg-white rounded-md">
            <div className="flex items-center p-3 bg-header ">
              <div className="w-6 h-6 rounded-full bg-gray-300 animate-pulse"></div>
              <div className="ml-2 w-20 h-5 bg-gray-300 rounded animate-pulse"></div>
            </div>
            <div className="p-4">
              <table className="w-full">
                <thead>
                  <tr>
                    <th className="text-left py-2 px-4">
                      <div className="W-15 h-4 bg-gray-300 rounded animate-pulse"></div>
                    </th>
                    <th className="text-left py-2 px-4">
                      <div className="w-15 h-4 bg-gray-300 rounded animate-pulse"></div>
                    </th>
                    <th className="text-left py-2 px-4">
                      <div className="w-15 h-4 bg-gray-300 rounded animate-pulse"></div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[...Array(3)].map((_, index) => (
                    <tr key={index}>
                      <td className="py-2 px-4">
                        <div className="w-15 h-4 bg-gray-300 rounded animate-pulse"></div>
                      </td>
                      <td className="py-2 px-4">
                        <div className="w-15 h-4 bg-gray-300 rounded animate-pulse"></div>
                      </td>
                      <td className="py-2 px-4">
                        <div className="w-15 h-4 bg-gray-300 rounded animate-pulse"></div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
      {Array.isArray(sortedArray) &&
      sortedArray.length > 0 &&
      !(isLoading || isFetching) ? (
        <>
          <div className="flex justify-between bg-white px-3 py-3 text-center shadow-md rounded-lg">
            <h3 className="flex-1  font-medium text-dark">
              {sortedArray[0]?.height?.toFixed(2)}
              <span className=""> cm </span>
              <br />
              {sortedArray[0]?.weight?.toFixed(2)} <span className="">kg</span>{" "}
              <br />
              <span className="text-sm text-gray-500">Start</span>
            </h3>
            <div className="w-[2px] bg-gray"></div>
            <h3 className="flex-1 font-medium text-dark">
              {sortedArray[sortedArray.length - 1]?.height?.toFixed(2)}{" "}
              <span className="">cm</span>
              <br />
              {sortedArray[sortedArray.length - 1]?.weight?.toFixed(2)}{" "}
              <span className="">kg</span> <br />
              <span className="text-sm text-gray-500">Today</span>
            </h3>
            <div className="w-[2px] bg-gray"></div>
            <h3 className="flex-1 font-medium text-dark">
              {Number(
                Number(sortedArray[sortedArray.length - 1]?.height) -
                  Number(sortedArray[0]?.height)
              ).toFixed(2)}{" "}
              <span className="">cm</span>
              <br />
              {Number(
                Number(sortedArray[sortedArray.length - 1]?.weight) -
                  Number(sortedArray[0]?.weight)
              ).toFixed(2)}{" "}
              <span className="">kg</span> <br />
              <span className="text-sm text-gray-500">Change</span>
            </h3>
          </div>

          <Item
            item={measurements}
            currentIndex={currentIndex}
            setCurrentIndex={setCurrentIndex}
          />
        </>
      ) : null}
    </>
  );
};

export default Measurement1;
